import { addItem } from '@nutima-themes/utils/cart'
import { EVENTS, publish } from '@nutima-themes/utils/pubsub'

class ProductForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.submitButton = this.querySelector('[type="submit"]')
    this.submitButtonText = this.submitButton.querySelector('span')
    this.hideErrors = this.dataset.hideErrors === 'true'
    this.productHandle = this.dataset.productHandle
  }

  connectedCallback() {
    this.setupEventListeners()
  }

  setupEventListeners() {
    if (!this.form) return
    this.form.addEventListener('submit', (e) => this.handleSubmit(e))
  }

  async handleSubmit(event) {
    event.preventDefault()

    this.submitButton.classList.add('button--loading')
    const formData = new FormData(this.form)

    const variantId = formData.get('id')
    const quantity = formData.get('quantity') || 1
    const sellingPlan = formData.get('selling_plan') || null
    
    try {
      await addItem(variantId, quantity, sellingPlan, this.productHandle)
      publish(EVENTS.drawerOpen)
      if (window.FancyModal) {
        window.FancyModal.close()
      }
    } catch (error) {
      console.log(error)
      this.handleErrorMessage(error.message)
    }

    this.submitButton.classList.remove('button--loading')
  }
  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
    if (!this.errorMessageWrapper) return
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage
    }
  }

  toggleSubmitButton(disable = true, text) {
    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled')
      if (text) this.submitButtonText.textContent = text
    } else {
      this.submitButton.removeAttribute('disabled')
      this.submitButtonText.textContent = window.variantStrings.addToCart
    }
  }

  get variantIdInput() {
    return this.form.querySelector('[name=id]')
  }
}

customElements.define('product-form', ProductForm)
